var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "energyLabel" },
    [
      _c("div", { class: _vm.withCustomImageClass ? "" : "picto" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _vm.energyLabel.labelImage
              ? _c(
                  "button",
                  {
                    staticClass: "border-0 bg-transparent",
                    attrs: {
                      "data-bs-target": _vm.withPopin
                        ? "#modal-energyLabel" + _vm.id
                        : null,
                      "data-bs-toggle": _vm.withPopin ? "modal" : null,
                      "data-oevent-category": _vm.dataOeventCategory,
                      "data-oevent-label":
                        "indice_" + _vm.energyLabel.efficiencyClass,
                      "data-oevent-action": _vm.energyLabel.sheetUrl,
                      title:
                        "Ouvrir la fiche d'information énergétique du produit",
                    },
                    on: { click: _vm.handleLabelClick },
                  },
                  [
                    _c("img", {
                      class: [
                        "align-self-center",
                        _vm.withCustomImageClass ? "img-size" : "my-1",
                      ],
                      attrs: {
                        alt:
                          "terminal de classe énergétique " +
                          _vm.energyLabel.efficiencyClass,
                        src: _vm.energyLabel.efficiencyClassImage,
                      },
                    }),
                  ]
                )
              : _vm.energyLabel.sheetUrl
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.sheetHref,
                      target: "_blank",
                      "data-oevent-category": _vm.dataOeventCategory,
                      "data-oevent-label":
                        "indice_" + _vm.energyLabel.efficiencyClass,
                      "data-oevent-action": _vm.energyLabel.sheetUrl,
                      title:
                        "Ouvrir la fiche d'information énergétique du produit",
                    },
                  },
                  [
                    _c("img", {
                      class: [
                        "align-self-center",
                        _vm.withCustomImageClass ? "img-size" : "my-1",
                      ],
                      attrs: {
                        alt:
                          "terminal de classe énergétique " +
                          _vm.energyLabel.efficiencyClass,
                        src: _vm.energyLabel.efficiencyClassImage,
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.withLink
              ? [
                  _vm.hasLabelOrSheet
                    ? _c(
                        "a",
                        {
                          staticClass: "ps-1",
                          attrs: { href: _vm.sheetHref, target: "_blank" },
                        },
                        [
                          _c("strong", {
                            domProps: {
                              innerHTML: _vm._s(_vm.energyLabel.popinLinkLabel),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.withPopin
        ? _c(
            "ob1-popin-modal2",
            {
              attrs: {
                id: "modal-energyLabel" + _vm.id,
                "aria-labelledby": "modal-label-energyLabel" + _vm.id,
              },
            },
            [
              _c("p", {
                staticClass: "h4",
                attrs: { id: "modal-label-energyLabel" + _vm.id },
                domProps: { innerHTML: _vm._s(_vm.energyLabel.popinTitle) },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "w-50",
                attrs: { alt: "", src: _vm.energyLabel.labelImage },
              }),
              _vm._v(" "),
              _vm.energyLabel.sheetUrl
                ? _c("ob1-liens", {
                    attrs: {
                      "with-arrow": true,
                      "is-large": true,
                      text: _vm.energyLabel.sheetLinkLabel,
                      href: _vm.sheetHref,
                      target: "_blank",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }